import BaseController from './BaseController'
import Scrollbar from 'smooth-scrollbar'

export default class EventController extends BaseController {

  init() {
    this.initScrollbar()
    // this.revealAnimate()
    // this.listeners()
    // this.openings()
    // this.contact()

    this.slider();
    this.$dones = []
  }

  listeners() {
    // this.scrollbar.addListener(() => { this._handleReveals() })
  }

  slider() {
    let numberSlide
    if(window.innerWidth < 769) {
        numberSlide = 1
    } else {
        numberSlide = 4
    }
    $(document).ready(function() {

        $('.slider__content').each(function(i, obj) {
            var slider_id = $(this).attr('id')
            
            $('#' + slider_id + ' .slider__slides').slick({
                infinite: false,
                dots: true,
                slidesToShow: numberSlide,
                slidesToScroll: 1,
                swipeToSlide: true,
                mobileFirst: true,
                variableWidth: true,
                appendArrows: '#' + slider_id + ' .slider__arrows-wrapper',
                responsive: [{
                        breakpoint: 900,
                        settings: {
                            slidesToShow: 2,
                            slidesToScroll: 1,
                        }
                    },
                    {
                        breakpoint: 1000,
                        settings: {
                            slidesToShow: 3,
                            slidesToScroll: 1,
                        }
                    }
                ]
            })
            let $progressBar = $('#' + slider_id + ' .slider__progress');
            let $slider = $('#' + slider_id + ' .slider__slides');
            let isSliding;
             $slider.on('beforeChange', function(event, slick, currentSlide, nextSlide) { 
                console.log('before')
                isSliding = true;
                let number = slick.$dots[0].childElementCount - 1
                let calc = ( (nextSlide) / (number)) * 100;
                $progressBar
                .css('background-size', calc + '% 100%')
                .attr('aria-valuenow', calc );
                
            });
            $slider.on('afterChange', function(event, slick, currentSlide, nextSlide) {  
                console.log('after')
                isSliding = false
            });
            $slider.on('click',  (event) => {
                if (isSliding) {
                    console.log('in')
                    event.stopImmediatePropagation();
                    event.stopPropagation();
                    event.preventDefault();
                    return;
                }
            });
        
        });

        $('.slider__year').click(function(){
            $('.slider__year').removeClass('active')
            $('.slider__content ').removeClass('active')
            $(this).addClass('active')
            $('#slider__slides_' + $(this).data('year') ).addClass('active')
        })
    })
}


}